import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

export default class AdminStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "AdminStore",
      properties: [
        "admins",
        "adminsTotalCount",
        "permissions",
        "roles",
        "singleNews",
        "singleBroadcast",
        "plans",
        "mimaPlans",
        "fashPlans",
        "tags",
        "businessesList",
        "participants",
        "competitions",
      ],
    });
  }

  admins = [];
  permissions = [];
  adminsTotalCount = 0;
  roles = [];
  singleNews = {};
  singleBroadcast = {};
  plans = [];
  fashPlans = [];
  mimaPlans = [];
  tags = [];
  businessesList = [];
  participants = [];
  competitions = [];

  reset = () => {
    this.admins = [];
    this.permissions = [];
    this.adminsTotalCount = 0;
    this.roles = [];
    this.singleNews = {};
    this.singleBroadcast = {};
    this.plans = [];
    this.mimaPlans = [];
    this.fashPlans = [];
    this.tags = [];
    this.businessesList = [];
    this.participants = [];
    this.competitions = [];
  };

  setAdmins = async (admins) => {
    runInAction(() => {
      this.admins = admins;
    });
  };

  setPermissions = async (state) => {
    runInAction(() => {
      this.permissions = state;
    });
  };

  setAdminsTotalCount = async (counts) => {
    runInAction(() => {
      this.adminsTotalCount = counts;
    });
  };
  setRoles = async (state) => {
    runInAction(() => {
      this.roles = state;
    });
  };
  setSingleNews = async (state) => {
    runInAction(() => {
      this.singleNews = state;
    });
  };
  setSingleBroadcast = async (state) => {
    runInAction(() => {
      this.singleBroadcast = state;
    });
  };
  setPlans = async (state) => {
    runInAction(() => {
      this.plans = state;
    });
  };
  setFashPlans = async (state) => {
    runInAction(() => {
      this.fashPlans = state;
    });
  };
  setMimaPlans = async (state) => {
    runInAction(() => {
      this.mimaPlans = state;
    });
  };
  setTags = async (state) => {
    runInAction(() => {
      this.tags = state;
    });
  };
  setBusinessesList = async (state) => {
    runInAction(() => {
      this.businessesList = state;
    });
  };
  setParticipants = async (state) => {
    runInAction(() => {
      this.participants = state;
    });
  };
  setCompetitions = async (state) => {
    runInAction(() => {
      this.competitions = state;
    });
  };
}
